// Fuente única de verdad para la navegación
// Orden: Services, FAQ, Coach, Process, Gallery, Roadmap, Camps, Contact

export const NAV_ITEMS = [
  {
    label: "Services",
    type: "section",
    id: "services"
  },
  {
    label: "FAQ",
    type: "section",
    id: "faq"
  },
  {
    label: "Coach",
    type: "section",
    id: "coach"
  },
  {
    label: "Process",
    type: "section",
    id: "process"
  },
  {
    label: "Gallery",
    type: "section",
    id: "gallery"
  },
  {
    label: "Roadmap",
    type: "route",
    path: "/roadmap"
  },
  {
    label: "Camps",
    type: "route",
    path: "/camps"
  },
  {
    label: "Contact",
    type: "route",
    path: "/contact"
  }
]

export const WHATSAPP_NUMBER = "643091350"

// CallMeBot WhatsApp API configuration for coach notifications
// To set up: Coach sends "I allow callmebot to send me messages" to +34 644 31 22 50
// Then receives an apikey to use here
export const CALLMEBOT_CONFIG = {
  phone: "34643091350", // Coach phone number with country code (no + sign)
  apikey: "123456" // Replace with actual apikey from CallMeBot
}
